module.exports = __webpack_public_path__ + "static/img/photo.e59111a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/divinemap/photo.jpg
// module id = OTGN
// module chunks = 1